import React, { useState, useRef, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { Link, useNavigate } from "react-router-dom";

import { getFlags, getBlogs, getCountries, getDepartments, getPrograms, getProjects, getResearches, getPartners, getPublications, createChat } from '../../routes/UserAction';

import { domainUrl, domain, timeFormat, reduceText } from '../../data/dummyData';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';


import OwlCarousel from "react-owl-carousel3";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import "./Carousel.css";


const HomePage = () => {
    const dispatch = useDispatch();

    const {
        loading,
        user,
        error,
        success,
        successMessage,
    } = useSelector((state) => state.user || {});
    const userData = user;

    // const userState = useSelector((state) => state.persist?.user);
    // const {
    //     loading,
    //     user,
    //     error,
    //     success,
    //     successMessage
    // } = userState || {};

    // console.log('userData...', userData)

    const navigate = useNavigate();
    const navigateToRoute = (url) => {
        // 👇️ navigate to /contacts
        navigate(url);
    };

    const [flags, setFlags] = useState([]);
    const [blogs, setBlogs] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [countries, setCountries] = useState([]);
    const [programs, setPrograms] = useState([]);
    const [projects, setProjects] = useState([]);
    const [researches, setResearches] = useState([]);
    const [partners, setPartners] = useState([]);
    const [publications, setPublications] = useState([]);


    const fetchFlags = () => {
        dispatch(getFlags())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setFlags(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetchBlogs = () => {
        // dispatch(getBlogs())
        dispatch(getBlogs({ fromHome: true }))
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setBlogs(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetchCountries = () => {
        dispatch(getCountries())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setCountries(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetchDepartments = () => {
        dispatch(getDepartments())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setDepartments(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetchPrograms = () => {
        dispatch(getPrograms({ fromHome: true }))
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setPrograms(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetchProjects = () => {
        dispatch(getProjects({ fromHome: true }))
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setProjects(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetcResearches = () => {
        dispatch(getResearches({ fromHome: true }))
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setResearches(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetchPartners = () => {
        dispatch(getPartners())
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setPartners(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const fetcPublications = () => {
        dispatch(getPublications({ fromHome: true }))
        .then(response =>{
            let resData = response?.payload?.data;
            const editableData = resData?.map(o => ({ ...o }));
            setPublications(editableData);
        })
        .catch((error) => {
            console.log(error)
        })
    }
    
    useEffect(() => {
        fetchFlags();
        fetchBlogs();
        fetchCountries();
        fetchDepartments();
        fetchPrograms();
        fetchProjects();
        fetcResearches();
        fetchPartners();
        fetcPublications();
    }, [])

    const options = {
        loop: true,
        margin: 10,
        nav: true, // ✅ Enable navigation arrows
        dots: false, // Hide dots if not needed
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        items: 1,
        navText: [
            "<i class='bi bi-arrow-left custom-arrow'></i>",
            "<i class='bi bi-arrow-right custom-arrow'></i>",
        ], // ✅ Custom arrows
    };

    const options2 = {
        loop: true,
        margin: 10,
        nav: true, // ✅ Enable navigation arrows
        dots: false, // Hide dots if not needed
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        },
        navText: [
            "<i class='bi bi-arrow-left custom-arrow text-white'></i>",
            "<i class='bi bi-arrow-right custom-arrow text-white'></i>",
        ], // ✅ Custom arrows
    };

    const options3 = {
        loop: true,
        margin: 10,
        nav: false,
        dots: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        // items: 3,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        }
    };

    const options4 = {
        loop: true,
        margin: 10,
        nav: true,
        dots: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1, // 1 item for small screens (mobile)
            },
            600: {
                items: 2, // 2 items for medium screens (tablets)
            },
            1000: {
                items: 3, // 3 items for larger screens (desktops)
            }
        },
        navText: [
            "<div class='owl-prev'><i class='fas fa-chevron-left'></i></div>",
            "<div class='owl-next'><i class='fas fa-chevron-right'></i></div>",
        ],
    };

    const startContact = (row) => {
        dispatch(createChat({
            msg: "A chat for publication, "+row.name,
            user_id: row.user_id
        }))
        .then((res) => {
            alert(res?.payload?.data);
        })
        .catch((err) => {
            console.error(err);
        });
    }

    

    return (
       <>

            <Header page={'home'} />
            {/* <Header page={'chat'} noSearch={true}/> */}

            {/* <!-- Spinner Start --> */}
            {/* <div id="spinner" className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
                <div className="spinner-border text-primary" style={{width: '3rem', height: '3rem'}} role="status">
                    <span className="sr-only">Loading...</span>
                </div>
            </div> */}
            {/* <!-- Spinner End --> */}



            

            {/* <OwlCarousel
                className="owl-theme"
                loop
                margin={10}
                nav
                dots
                autoplay
                autoplayTimeout={3000}
                items={1}
            > */}

            {/* {blogs?.filter(el => el.type == 0)?.length ? blogs.filter(el => el.type == 0).map((row) => (
               <></> 
            )) : <></>} */}

            {/* {flags?.filter(el => (el.name== 'emy_mission' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_mission' && el.type == 1))[0].value : <></>} */}

<           OwlCarousel
                className="header-carousel owl-carousel"
                {...options}
            >

                {blogs?.filter(el => el.type == 0)?.length ? blogs.filter(el => el.type == 0).map((row) => (
                    <div key={row.id} className="header-carousel-item hero-section" style={{
                        backgroundImage: `url(${row.image ? domain+row.image : "./assets/img/emy.png"})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        backgroundSize: 'contain',
                        width: '100%',
                        height: '700px',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        overflow: 'hidden',
                    }}>
                        <div className="hero-bg-half-1" style={{
                            clipPath: "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)",
                            filter: "grayscale(15%)",
                            transform: 'scale(0.5)', // or remove if not needed
                            backgroundPosition: 'center right',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            position: 'absolute',
                            width: '58%',
                            height: '100%',
                            right: 0,
                            top: 0,
                        }}></div>
                        <div className="carousel-caption">
                            <div className="container">
                                <div className="row g-4 align-items-center">
                                    <div className="col-lg-7 animated fadeInLeft">
                                        <div className="text-sm-center text-md-start">
                                            <h4 className="text-primary text-uppercase fw-bold mb-4">
                                                Welcome to our EmyLab Center
                                            </h4>
                                            <h1 className="display-1 text-white mb-4">
                                                {row.name? row.name: ''}
                                            </h1>
                                            <p className="mb-5 fs-5">
                                                {row.about? row.about: ''}
                                            </p>
                                            {/* <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                                                <a style={{ backgroundColor: 'darkgreen' }} className="btn btn-dark py-3 px-4 px-md-5 me-2" href="#">
                                                    <i className="fas fa-play-circle me-2"></i> <span>Watch Video</span>
                                                </a>
                                                <a className="btn btn-primary py-3 px-4 px-md-5 ms-2" href="#">
                                                    <span>Learn More</span>
                                                </a>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )) : <>
                    <div className="header-carousel-item hero-section" style={{ 
                        backgroundImage: "url('./assets/img/emy.png')",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        // backgroundSize: 'cover',
                        backgroundSize: 'contain',
                        width: '100%',
                        height:' 700px',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        overflow: 'hidden',
                    }}>
                        <div className="hero-bg-half-1" style={{ 
                            // backgroundImage: "url('./assets/img/emylogo3.png')",
                            clipPath: "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)",
                            filter: "grayscale(15%)",
                            transform: 'scale(100% - 50%)',
                            backgroundPosition: 'center right',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            position: 'absolute',
                            width: '58%',
                            height: '100%',
                            right: 0,
                            top: 0,
                        }}></div>
                        <div className="carousel-caption">
                        <div className="container">
                            <div className="row g-4 align-items-center">
                            <div className="col-lg-7 animated fadeInLeft">
                                <div className="text-sm-center text-md-start">
                                <h4 className="text-primary text-uppercase fw-bold mb-4">
                                    Welcome to our EmyLab Center
                                </h4>
                                <h1 className="display-1 text-white mb-4">
                                    The best gym center is now in your city
                                </h1>
                                <p className="mb-5 fs-5">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy...
                                </p>
                                <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                                    <a style={{backgroundColor: 'darkgreen'}}  className="btn btn-dark py-3 px-4 px-md-5 me-2" href="#">
                                    <i className="fas fa-play-circle me-2"></i> <span>Watch Video</span>
                                    </a>
                                    <a className="btn btn-primary py-3 px-4 px-md-5 ms-2" href="#">
                                    <span>Learn More</span>
                                    </a>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="header-carousel-item hero-section" style={{ 
                        backgroundImage: "url('./assets/img/soft.png')",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        // backgroundSize: 'cover',
                        backgroundSize: 'contain',
                        width: '100%',
                        height:' 700px',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        overflow: 'hidden',
                    }}>
                        <div className="hero-bg-half-1" style={{ 
                            // backgroundImage: "url('./assets/img/emylogo3.png')",
                            clipPath: "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)",
                            filter: "grayscale(15%)",
                            transform: 'scale(100% - 50%)',
                            backgroundPosition: 'center right',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            position: 'absolute',
                            width: '58%',
                            height: '100%',
                            right: 0,
                            top: 0,
                        }}></div>
                        <div className="carousel-caption">
                        <div className="container">
                            <div className="row g-4 align-items-center">
                            <div className="col-lg-7 animated fadeInLeft">
                                <div className="text-sm-center text-md-start">
                                <h4 className="text-primary text-uppercase fw-bold mb-4">
                                    Welcome to our EmyLab Center
                                </h4>
                                <h1 className="display-1 text-white mb-4">
                                    The best gym center is now in your city
                                </h1>
                                <p className="mb-5 fs-5">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy...
                                </p>
                                <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                                    <a style={{backgroundColor: 'darkgreen'}}  className="btn btn-dark py-3 px-4 px-md-5 me-2" href="#">
                                    <i className="fas fa-play-circle me-2"></i> <span>Watch Video</span>
                                    </a>
                                    <a className="btn btn-primary py-3 px-4 px-md-5 ms-2" href="#">
                                    <span>Learn More</span>
                                    </a>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>

                    <div className="header-carousel-item hero-section" style={{ 
                        backgroundImage: "url('./assets/img/afro.png')",
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center center',
                        // backgroundSize: 'cover',
                        backgroundSize: 'contain',
                        width: '100%',
                        height:' 700px',
                        display: 'flex',
                        alignItems: 'center',
                        position: 'relative',
                        overflow: 'hidden',
                    }}>
                        <div className="hero-bg-half-2" style={{ 
                            // backgroundImage: "url('./assets/img/emylogo3.png')",
                            clipPath: "polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)",
                            filter: "grayscale(15%)",
                            transform: 'scale(100% - 50%)',
                            backgroundPosition: 'center right',
                            backgroundRepeat: 'no-repeat',
                            backgroundSize: 'cover',
                            position: 'absolute',
                            width: '58%',
                            height: '100%',
                            right: 0,
                            top: 0,
                        }}></div>
                        <div className="carousel-caption">
                        <div className="container">
                            <div className="row g-4 align-items-center">
                            <div className="col-lg-7 animated fadeInLeft">
                                <div className="text-sm-center text-md-start">
                                <h4 className="text-primary text-uppercase fw-bold mb-4">
                                    Welcome to our EmyLab Center
                                </h4>
                                <h1 className="display-2 text-white mb-4">
                                    Stay healthy by exercising at the best gym center
                                </h1>
                                <p className="mb-5 fs-5">
                                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy...
                                </p>
                                <div className="d-flex justify-content-center justify-content-md-start flex-shrink-0 mb-4">
                                    <a className="btn btn-dark py-3 px-4 px-md-5 me-2" href="#">
                                    <i className="fas fa-play-circle me-2"></i> <span>Watch Video</span>
                                    </a>
                                    <a className="btn btn-primary py-3 px-4 px-md-5 ms-2" href="#">
                                    <span>Learn More</span>
                                    </a>
                                </div>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                </>}
                
                

            </OwlCarousel>

            {/* <!-- About Start --> */}
            <div className="container-fluid about pt-5" style={{zIndex: 1}}>
                <div className="container pt-5">
                    <div className="row g-5">
                        <div className="col-xl-6 wow fadeInLeft" data-wow-delay="0.2s">
                            <div className="about-content h-100">
                                <h4 className="" style={{color: 'gold'}}>About MJ-EmyLab</h4>
                                <h1 className="display-4 text-white mb-4">{flags?.filter(el => (el.name== 'emy_about1' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_about1' && el.type == 1))[0].value : <></>}</h1>
                                <p className="mb-4 text-white">{flags?.filter(el => (el.name== 'emy_about2' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_about2' && el.type == 1))[0].value : <></>}</p>
                                <div className="tab-class pb-4">
                                    <ul className="nav d-flex mb-2">
                                        <li className="nav-item mb-3">
                                            <a className="d-flex py-2 active" data-bs-toggle="pill" href="#tab-1">
                                                <span style={{width: '150px'}}>Our Mission</span>
                                            </a>
                                        </li>
                                        <li className="nav-item mb-3">
                                            <a className="d-flex py-2 mx-3" data-bs-toggle="pill" href="#tab-2">
                                                <span style={{width: '150px'}}>Our Vision</span>
                                            </a>
                                        </li>
                                        <li className="nav-item mb-3">
                                            <a className="d-flex py-2" data-bs-toggle="pill" href="#tab-3">
                                                <span style={{width: '150px'}}>Our Goal</span>
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content">
                                        <div id="tab-1" className="tab-pane fade show p-0 active">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="d-flex align-items-center border-top border-bottom py-4">
                                                        <span className="fas fa-rocket text-white fa-4x me-4"></span>
                                                        <p className="mb-0 text-success">
                                                            {flags?.filter(el => (el.name== 'emy_mission' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_mission' && el.type == 1))[0].value : <></>}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="tab-2" className="tab-pane fade show p-0">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="d-flex align-items-center border-top border-bottom py-4">
                                                        <span className="fas fa-rocket text-white fa-4x me-4"></span>
                                                        <p className="mb-0 text-success">
                                                            {flags?.filter(el => (el.name== 'emy_vision' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_vision' && el.type == 1))[0].value : <></>}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div id="tab-3" className="tab-pane fade show p-0">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="d-flex align-items-center border-top border-bottom py-4">
                                                        <span className="fas fa-rocket text-white fa-4x me-4"></span>
                                                        <p className="mb-0 text-success">
                                                            {flags?.filter(el => (el.name== 'emy_goal' && el.type == 1))?.length ? flags.filter(el => (el.name== 'emy_goal' && el.type == 1))[0].value : <></>}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row g-4 align-items-center">
                                    <div className="col-sm-6">
                                        <Link to={'/contact'} className="btn btn-primary py-3 px-5"> <span>For Enquiries</span></Link>
                                    </div>
                                    <div className="col-sm-6">
                                        <div className="d-flex flex-shrink-0 ps-4">
                                            <a href="#" className="btn btn-light btn-lg-square position-relative wow tada" data-wow-delay=".9s">
                                                <i className="fa fa-phone-alt fa-2x"></i>
                                                <div className="position-absolute" style={{top: '5px', right: '5px'}}>
                                                    <span><i className="fa fa-comment-dots text-dark"></i></span>
                                                </div>
                                            </a>
                                            <div className="d-flex flex-column ms-3">
                                                {/* <span>Contact</span> */}
                                                <a
                                                    href={`tel:${flags?.find(el => el.name === 'emy_phone' && el.type === 1)?.value || '(+233) 559 148 214'}`}
                                                >
                                                    <span className="text-white">
                                                        {flags?.find(el => el.name === 'emy_phone' && el.type === 1)?.value || '(+233) 559 148 214'}
                                                    </span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-6 wow fadeInUp" data-wow-delay="0.2s">
                            <div className="about-img h-100">
                                <div className="about-img-inner d-flex h-100">
                                    <img src={flags?.filter(el => (el.name== 'emy_logo' && el.type == 1))?.length ? domain+flags.filter(el => (el.name== 'emy_logo' && el.type == 1))[0].value : "./assets/img/emy.png"} className="img-fluid w-100" style={{objectFit: 'contain'}} alt=""/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- About End --> */}

            {/* <!--Countries Start --> */}
            <div className="container-fluid feature">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        <h4 className="" style={{color: 'gold'}}> EmyCountries</h4>
                        <h1 className="display-4 mb-4">Countries we are legally registered</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam.
                        </p> */}
                    </div>

                    <OwlCarousel
                        className="feature-carousel owl-carousel"
                        {...options2}
                    >
                    {/* <div className="feature-carousel owl-carousel"> */}
                        {countries?.filter(el => el.type == 0)?.length ? countries.filter(el => el.type == 0).map((row) => (
                            <div key={row.id} className="feature-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="feature-img">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100"  alt=""/>
                                </div>
                                <div className="feature-content p-4">
                                    <h4 className="mb-3">{row.name? row.name: ''}</h4>
                                    <p className="mb-4">
                                        {row.about? row.about: ''}
                                    </p>
                                    <Link to={row.uuid? `/country?id=${row.uuid}`:'/'} className="btn btn-primary py-2 px-4"> <span>Read More</span></Link>
                                </div>
                            </div>
                        )) : null}
                        
                    {/* </div> */}
                    </OwlCarousel>
                    <div className="feature-shaps"></div>
                </div>
            </div>
            {/* <!-- Countries End --> */}

            {/* <!-- Departments Start --> */}
            <div className="container-fluid team py-5" style={{ 
                position: 'relative',
                overflow: 'hidden',
                background: "linear-gradient(rgba(255, 245, 225, 0.9), rgba(132, 199, 137, 0.9)), url('./assets/img/afro.png')",
                backgroundPosition: 'center center',
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
            }}>
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        <h4 className="" style={{color: 'gold'}}>EmyLabs</h4>
                        <h1 className="display-4 mb-4">Our departments</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                        </p> */}
                    </div>
                    <div className="row gy-5 gy-lg-4 gx-4">
                        {departments?.length? departments.map((row) => (
                            <div key={row.id} className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s">
                                <div className="team-item">
                                    <div className="team-img">
                                        <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100" alt="Image"/>
                                        <div className="team-icon">
                                            <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-facebook-f"></i></a>
                                            <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-twitter"></i></a>
                                            <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-instagram"></i></a>
                                            <a href="#" className="btn btn-primary btn-sm-square"><i className="fab fa-linkedin-in"></i></a>
                                        </div>
                                    </div>
                                    <div className="team-content">
                                        <h4>{row.name? row.name: ''}</h4>
                                        <p className="mb-0">{row.status ==1? 'Active': 'Inactive'}</p>
                                    </div>
                                </div>
                            </div>
                        )) : <></>}
                        
                    </div>
                </div>
            </div>
            {/* <!-- Departments End --> */}

            {/* <!-- Blog Start --> */}
            <div className="container-fluid blog py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        {/* <h4 className="text-primary">  Our Blogs</h4> */}
                        <h4 className="" style={{color: 'gold'}}> EmyUpdates </h4>
                        <h1 className="display-4 mb-4">Our Blogs & Stories</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                        </p> */}
                    </div>

                    <OwlCarousel
                        className="blog-carousel owl-carousel"
                        {...options3}
                    >
                    {/* <div className="blog-carousel owl-carousel"> */}
                        {blogs?.filter(el => el.type == 1)?.length ? blogs.filter(el => el.type == 1).map((row) => (
                            <div className="blog-item wow fadeInUp" key={row.id} data-wow-delay="0.2s">
                                <div className="blog-img p-4 pb-0">
                                    <a href="#">
                                        <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100" alt=""/>
                                    </a>
                                </div>
                                <div className="blog-content p-4">
                                    <div className="blog-comment d-flex justify-content-between py-2 px-3 mb-4">
                                        <div className="small"> <span className='text-primary mr-2'> <i className="bi bi-eye-fill text-primary"></i> {row?.views? row.views.length: 0}</span><span className='text-primary'> <i className="bi bi-heart-fill text-primary"></i> {row?.likes? row.likes.length: 0}</span></div>
                                        <div className="small text-primary"><span className="fa fa-calendar text-primary me-2"></span> {timeFormat(row.created_at)}</div>
                                    </div>
                                    <a href="#" className="h4 d-inline-block mb-3">{row.name? row.name: ''}</a>
                                    <p className="mb-3">{row.about? reduceText(row.about, 200, '...'): ''}</p>
                                    <Link to={row.uuid? `/blog?id=${row.uuid}`:'/'} className="btn btn-dark py-2 px-4 ms-2"> <span className="me-2">Read More</span>  <i className="fa fa-arrow-right"></i></Link>
                                </div>
                            </div>
                        )) : <></>}
                        
                    {/* </div> */}
                    </OwlCarousel>
                </div>
            </div>
            {/* <!-- Blog End --> */}

            {/* <!-- Programs Start --> */}
            <div className="container-fluid courses overflow-hidden py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        {/* <h4 className="text-primary"> Our Courses</h4> */}
                        <h4 className="" style={{color: 'gold'}}> EmyPrograms</h4>
                        <h1 className="display-4 text-white mb-4">Our Programs</h1>
                        {/* <p className="text-white mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                        </p> */}
                    </div>
                    <div className="row gy-4 gx-0 justify-content-center">
                        {programs?.filter(el => el.type == 1)?.length ? programs.filter(el => el.type == 1).map((row) => (
                            <div key={row.id} className="col-md-6 col-lg-4 wow fadeInUp" data-wow-delay="0.2s">
                                <div className="courses-item">
                                    <div className="courses-item-inner p-4" style={{ 
                                        // backgroundImage: "url('./assets/img/emy.png')",
                                        backgroundImage: `url(${row.image ? domain+row.image : "./assets/img/emy.png"})`,
                                        backgroundRepeat: 'no-repeat',
                                        backgroundPosition: 'center center',
                                        // backgroundSize: 'cover',
                                        backgroundSize: 'contain',
                                    }}>
                                        <div className="d-flex justify-content-between mb-4">
                                            {/* <div className="courses-icon-img p-3">
                                                <img src="./assets/img/soft.png" className="img-fluid" alt=""/>
                                            </div> */}
                                            <div className="data-info d-flex flex-column">
                                                {/* <div className="courses-trainer d-flex align-items-center mb-1">
                                                    <div className="me-2" style={{width: '25px', height: '25px'}}>
                                                        <img src="./assets/img/soft.png" className="img-fluid" alt=""/>
                                                    </div>
                                                    <p className="mb-0">Paul Flavius</p>
                                                </div> */}
                                                <div className="courses-date">
                                                    <p className="mb-1">Posted: {timeFormat(row.created_at)}</p>
                                                    <p className="mb-0">Start: {row.schedules?.length ? `${row.schedules[0].start_at} - ${row.schedules[0].end_at}` : 'No schedule'}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <a href="#" className="d-inline-block h4 mb-3">{row.name}</a>
                                        <p className="mb-4">
                                            {row.about? reduceText(row.about, 200, '...'): ''}
                                        </p>
                                        <Link to={row.uuid? `/program?id=${row.uuid}`:'/'} className="btn btn-primary py-2 px-4"> <span>Read More</span></Link>
                                    </div>
                                </div>
                            </div>
                        )) : <></>}
                        
                        <div className="col-12 text-center wow fadeInUp" data-wow-delay="0.2s">
                        <Link to={'/programs'} className="btn btn-primary py-3 px-5"> <span>More Programs</span></Link>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- Programs End --> */}

            

            {/* <!-- Researches Start img --> */}
            <div className="container-fluid blog py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        {/* <h4 className="text-primary">  Our Blogs</h4> */}
                        <h4 className="" style={{color: 'gold'}}> EmyResearches</h4>
                        <h1 className="display-4 mb-4">Check out our latest researches</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                        </p> */}
                    </div>

                    <OwlCarousel
                        className="blog-carousel owl-carousel"
                        {...options3}
                    >
                    {/* <div className="blog-carousel owl-carousel"> */}
                        {researches?.filter(el => el.type == 1)?.length ? researches.filter(el => el.type == 1).map((row) => (
                            <div key={row.id} className="blog-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="blog-img p-4 pb-0">
                                    {/* <a href="#">
                                        <img src="./assets/img/soft.png" className="img-fluid w-100" alt=""/>
                                    </a> */}
                                </div>
                                <div className="blog-content p-4">
                                    {/* <div className="blog-comment d-flex justify-content-between py-2 px-3 mb-4"> */}
                                    <div className="blog-comment d-flex justify-content-center py-2 px-3 mb-4">
                                        {/* <div className="small"><span className="fa fa-user text-primary me-2"></span> Martin.C</div> */}
                                        <div className="small"><span className="fa fa-calendar text-primary me-2"></span> {timeFormat(row.created_at)}</div>
                                    </div>
                                    <a href="#" className="h4 d-inline-block mb-3">{row.about? reduceText(row.about, 200, '...'): ''}</a>
                                    <p className="mb-3">{row.about}</p>
                                    {/* <Link to={row.uuid? `/research?id=${row.uuid}`:'/'} className="btn btn-dark py-2 px-4 ms-2"> <span className="me-2">Read More</span>  <i className="fa fa-arrow-right"></i></Link> */}
                                </div>
                            </div>
                        )) : <></>}
                        
                    {/* </div> */}
                    </OwlCarousel>
                </div>
            </div>
            {/* <!-- Researches End --> */}

            {/* <!-- Explore EmySoftware Start --> */}
            <div className="container-fluid explore py-5 wow zoomIn" data-wow-delay="0.2s">
                <div className="container py-5 text-center">
                    <h1 className="display-1 text-white mb-0"> Visit Our Channel</h1>
                    <a className="btn btn-primary py-3 px-4 px-md-5 me-2" href={flags?.find(el => el.name === 'emy_youtube' && el.type === 1)?.value || "https://www.youtube.com/"}
                                                target="_blank">
                        <i className="fas fa-play-circle me-2"></i> <span>Watch Video</span>
                    </a>
                </div>
            </div>
            {/* <!-- Explore EmySoftware End --> */}

            {/* <!-- Partners Start imag --> */}
            <div className="container-fluid team py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        <h4 className="" style={{color: 'gold'}}>EmyPartners</h4>
                        <h1 className="display-4 mb-4">Our Partners</h1>
                        {/* <p className="mb-0">Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
                        </p> */}
                    </div>
                    <div className="row gy-5 gy-lg-4 gx-4">
                        {partners?.length ? partners.map((row) => (
                            <div key={row.id} className="col-md-6 col-lg-3 wow fadeInUp" data-wow-delay="0.2s" style={{ 
                                // backgroundImage: "url('./assets/img/emy.png')",
                                backgroundImage: `url(${row.image ? domain+row.image : "./assets/img/emy.png"})`,
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: 'center center',
                                // backgroundSize: 'cover',
                                backgroundSize: 'contain',
                            }}>
                                <div className="team-item">
                                    <div className="team-content">
                                        <h4>{row.name}</h4>
                                        <p className="mb-0">2024</p>
                                    </div>
                                </div>
                            </div>
                        )) : <></>}
                        
                    </div>
                </div>
            </div>
            {/* <!-- Partners End --> */}

            {/* <!-- Projects Start --> */}
            <div className="container-fluid testimonial bg-dark py-5" style={{marginBottom: '90px'}}>
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        <h4 className="" style={{color: 'gold'}}>EmyProjects</h4>
                        <h1 className="display-4 text-white">Our Projects</h1>
                    </div>

                    <OwlCarousel
                        className="testimonial-carousel owl-carousel wow fadeInUp" data-wow-delay="0.2s"
                        {...options4}
                    >
                    {/* <div className="testimonial-carousel owl-carousel wow fadeInUp" data-wow-delay="0.2s"> */}
                        {projects?.filter(el => el.type == 1)?.length ? projects.filter(el => el.type == 1).map((row) => (
                            <div key={row.id} className="testimonial-item mx-auto" style={{maxWidth: '900px'}}>
                                <span className="fa fa-quote-left fa-3x quote-icon"></span>
                                <div className="testimonial-img mb-4">
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid" alt="Image"/>
                                </div>
                                {/* <p className="fs-4 text-white mb-4">Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero quasi deleniti ratione similique eaque blanditiis fugit voluptas ex officiis expedita repellat doloribus veniam delectus tempore, laudantium, aliquam ad? Rem, accusantium?
                                </p> */}
                                <div className="d-block">
                                <Link to={row.uuid? `/project?id=${row.uuid}`:'/'}><h4 className="text-white">{row.name}</h4></Link>
                                    <p className="m-0 pb-3">{row.about? reduceText(row.about, 200, '...'): ''}</p>
                                    {/* <div className="d-flex">
                                        <i className="fas fa-star text-primary"></i>
                                        <i className="fas fa-star text-primary"></i>
                                        <i className="fas fa-star text-primary"></i>
                                        <i className="fas fa-star text-primary"></i>
                                        <i className="fas fa-star text-white"></i>
                                    </div> */}
                                </div>
                            </div>
                        )) : <></>}
                        
                    {/* </div> */}
                    </OwlCarousel>
                </div>
            </div>
            {/* <!-- Projects End --> */}

            
            {/* <!-- Publications Start img --> */}
            <div className="container-fluid blog py-5">
                <div className="container py-5">
                    <div className="text-center mx-auto pb-5 wow fadeInUp" data-wow-delay="0.2s" style={{maxWidth: '800px'}}>
                        {/* <h4 className="text-primary">  Our Blogs</h4> */}
                        <h4 className="" style={{color: 'gold'}}> EmyPublications</h4>
                        <h1 className="display-4 mb-4">Check out our latest publications</h1>
                        
                    </div>

                    <OwlCarousel
                        className="blog-carousel owl-carousel"
                        {...options3}
                    >
                    {/* <div className="blog-carousel owl-carousel"> */}
                        {publications?.filter(el => el.type == 1)?.length ? publications.filter(el => el.type == 1).map((row) => (
                            <div key={row.id} className="blog-item wow fadeInUp" data-wow-delay="0.2s">
                                <div className="blog-img p-4 pb-0">
                                    {/* <img src="./assets/img/soft.png" className="img-fluid w-100" alt=""/> */}
                                    <img src={row.image? domain+row.image:"./assets/img/soft.png"} className="img-fluid w-100" alt=""/>
                                </div>
                                <div className="blog-content p-4">
                                    {/* <div className="blog-comment d-flex justify-content-between py-2 px-3 mb-4"> */}
                                    <div className="blog-comment d-flex justify-content-center py-2 px-3 mb-4">
                                        {/* <div className="small"><span className="fa fa-user text-primary me-2"></span> Martin.C</div> */}
                                        <div className="small"><span className="fa fa-calendar text-primary me-2"></span> {timeFormat(row.created_at)}</div>
                                    </div>
                                    <a href="#" className="h4 d-inline-block mb-3">{row.name? row.name:''}</a>
                                    <p className="mb-3">{row.about? reduceText(row.about, 200, '...'): ''}</p>

                                    {row.form_id? 
                                        <div className='row mx-1'> <Link to={row.form_id? `/emyform/${row.form_id}`:'/'} className="mb-1 btn btn-primary py-2 px-4"> <span>View Form</span></Link>

                                        <Link to={row.form_id? `/emyformanswer/${row.form_id}`:'/'} className="btn btn-primary py-2 px-4"> <span>View Res</span></Link> </div>
                                    : null}

                                    <button type='button' onClick={() => startContact(row)}  className="btn btn-danger mt-2 mx-auto">Contact</button>

                                </div>
                            </div>
                        )) : <></>}
                        
                    {/* </div> */}
                    </OwlCarousel>
                </div>
            </div>
            {/* <!-- Publications End --> */}


            <Footer />

       </>
    )
}

export default HomePage